var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYearInReviewBall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 54,
    viewBox: "0 0 27 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9951 53.2595L9.80936 53.2484L9.78246 53.2326L3.59049 49.6579L0 43.4375V36.2565L3.59049 30.0376L3.61739 30.0202L9.80936 26.4456H16.9919L17.0188 26.4614L23.2108 30.0376L26.8013 36.2565V43.4375L23.2108 49.6579L23.1839 49.6738L16.9951 53.2595ZM9.87266 53.0095L16.9302 53.0222L23.0352 49.4823L26.5623 43.3742V36.3198L23.0352 30.2101L16.927 26.6829H9.87266L3.76297 30.2101L0.235779 36.3198V43.3742L3.76297 49.4823L9.87266 53.0095Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.021 49.6301L9.73828 26.625L9.944 26.5063L23.2268 49.5114L23.021 49.6301Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9885 53.2642L16.835 53.1961L16.8413 53.1107L17.5233 39.9688L23.1409 29.8983L26.8152 43.4422L26.7662 43.4896L16.9885 53.2642ZM17.7575 40.0368L17.0945 52.8227L26.551 43.371L23.0633 30.5234L17.7575 40.0368Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.305639 40.0111L0.0825195 39.932L3.59389 30.0055H23.124V30.2429H3.76162L0.305639 40.0111Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42628 36.4988L3.58252 30.1961L3.77083 30.0521L8.39463 36.0684L11.7462 30.0916L16.8906 26.4679L17.0283 26.6625L11.9044 30.2689L8.42628 36.4988Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.04351 44.571L0.0981445 39.952L8.40738 36.1542L8.45486 36.1747L17.9256 39.9899L9.04351 44.571ZM0.639329 39.9646L9.04351 44.3036L17.3559 40.0153L8.41213 36.4121L0.639329 39.9646Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9157 53.2627C16.8714 53.2627 16.8413 53.2343 16.8208 53.2042L3.64719 49.5251L3.64878 49.5172L3.6282 49.5362L0.121582 39.8676L26.6649 39.8534V40.0908L0.458635 40.105L3.72948 49.1216L9.05113 44.2715L17.0075 53.0507C17.0085 53.0549 17.0107 53.0597 17.0138 53.0649L17.0249 53.0903H17.0233C17.0423 53.1409 17.0518 53.2105 16.9695 53.2501C16.9495 53.2596 16.9315 53.2638 16.9157 53.2627ZM3.84816 49.3352L16.5359 52.8782L9.0353 44.607L3.84816 49.3352Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8345 26.5905H11.5972V24.4985H15.2035V26.5082H14.9661V24.7359H11.8345V26.5905Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7171 24.5195H13.4077V-8.99976L13.5624 -8.99712L13.7171 -8.99976V24.5195Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYearInReviewBall);
export default __webpack_public_path__ + "static/media/yearInReviewBall.7fa98f4b23ef3761a1466c3754fedeab.svg";
export { ForwardRef as ReactComponent };